export default __webpack_public_path__ + "images/payment_methods.png";